export const osStandardFilterFields = [
	'id',
	'materialTemplateRef',

	'organizationId',
	'propertyTypes',
] as const;

export const osDateFilterFields = ['createdAt', 'updatedAt'] as const;

export const filterFields = [...osStandardFilterFields, ...osDateFilterFields] as const;
